import React from "react";
import { TabList, Tab } from "@fluentui/react-tabs";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { ACTIONS } from "../../constants/Constants";
import { t } from "i18next";
import NextPreviousSection from "./NextPreviousSection";
import BackResIcon from "../SVGComponents/ResponsiveScreenIcon/BackResIcon";
import { useTranslation } from "react-i18next";
import { logout } from "../../service/UserService";

const MobileTabView = (props) => {

  const t = useTranslation();

  const handleLogout = async () => {
    console.log("Logout button clicked");
    await logout();
    window.location.assign("/");
  };

    return (<>
        <div className="left-side-tablist-mobile-cmp">
          {props.navigateUser.navigate ? (
            <>
              <div style={{ height: "100%" }}>
                <div className="view-details-mobile-top-header">
                  <div
                    onClick={() => props.setNavigateUser(false)}
                    style={{
                      display: "flex",
                      flex: "1 1 0",
                      alignItems: "center",
                    }}
                  >
                    {/* <BackResIcon color={"var(--navbar-header-popup-color-txt)"}/> */}
                    <BackResIcon color={"var(--mobile-color-txt)"}/>
                    </div>

                  <span
                    className="top-header-mobile-cmp"
                    style={{
                      display: "flex",
                      flex: "2 1 0",
                      justifyContent: "start",
                    }}
                  >
                    {props.navigateUser.headerName}
                  </span>
                </div>
                <div className="modal-scroll details-container-mobile-cmp">
                  {props.tabDetails.map((tabElement, index) => {
                    return (
                      props.uniqueKey + tabElement.selectedKey ==
                      props.selectedValue && 
                      <div
                    key={index}
                    className="modal-scroll"
                    style={{
                      height: "100%",
                      overflow: "auto"
                    }}
                  >
                      {tabElement.tabValueContain}
                      </div>
                    );
                  })}
                 
                </div>
                {props.previousNextButton && <div className="view-detail-bottom-mobile-container">
                    {props.previousNextButton &&  parseInt(
                          props.getNumberFromString(props.selectedValue)
                        ) != props.NoOfTabs && (
                        <NextPreviousSection
                          isMobile={props.isMobile}
                          prevDisabled={
                            parseInt(
                                props.getNumberFromString(props.selectedValue)
                            ) == 1
                              ? true
                              : false
                          }
                          nextDisabled={
                            props.NoOfTabs ==
                            parseInt(
                                props.getNumberFromString(props.selectedValue)
                            )
                              ? true
                              : false
                          }
                          handleNextClick={props.handleNextClick}
                          handlePreviousClick={props.handlePreviousClick}
                        />
                    )}
                    {props.routerState == null ||
                      ((props.routerState === ACTIONS.ADD ||
                        props.routerState === ACTIONS.EDIT) &&
                        parseInt(
                            props.getNumberFromString(props.selectedValue)
                        ) == props.NoOfTabs && (
                          <PrimaryButton
                              style={{
                                background: "#2F80ED",
                                borderRadius: "5px",
                                marginLeft:'10px'
                              }}
                            text={t("hospital.previous")}
                            onClick={props.handlePreviousClick}
                          />
                        ))}
                    {props.routerState == null ||
                      ((props.routerState === ACTIONS.ADD ||
                        props.routerState === ACTIONS.EDIT) &&
                        parseInt(
                            props.getNumberFromString(props.selectedValue)
                        ) == props.NoOfTabs && (
                          <PrimaryButton
                            style={{ marginRight: "10px" }}
                            text={t("button.save")}
                            onClick={props.onSubmitClick}
                          />
                        ))}
                    {props.routerState === ACTIONS.VIEW && (
                      <PrimaryButton
                        style={{ marginLeft: "10px" }}
                        text="Edit"
                        onClick={props.onEditClick}
                      />
                    )}
                  </div>}
              </div>
            </>
          ) : (
            <>
              <div
                style={{ justifyContent: "center", padding: "20px" }}
                className="top-header-mobile-cmp"
              >
                {props.mobileTabHeader}
              </div>
              <div className="modal-scroll list-view-mobile-cmp">
              <TabList
                selectedValue={props.selectedValue}
                onTabSelect={(event, data) =>
                  props.onMobileTabSelect(event, data, true)
                }
                vertical
              >
                {props.tabDetails.map((tabElement, index) => {
                  return (
                    <Tab
                      key={index}
                      className="tab-container-cmp"
                      id={`${props.uniqueKey}${(index + 1).toString()}`}
                      value={`${props.uniqueKey}${(index + 1).toString()}`}
                    >
                      {tabElement.tabKeyContain}
                    </Tab>
                  );
                })}
              </TabList>
              {props.mobileTabHeader == "Account And Settings" && 
              <div style={{margin:"0px 20px"}}>
              <PrimaryButton onClick={()=>{handleLogout()}} style={{width:"100%"}} text="Logout" />
              </div>}
              </div>
             
            </>
          )}
        </div>
    </>)
}

export default MobileTabView;